export const TERMS_AND_CONDITIONS_URL = 'https://paywell.ca/terms'
